<ng-template [ngIf]="isVisible()" class="autocomplete-search">
  <input type="text" class="form-control" placeholder="Search {{ label }}" [(ngModel)]="searchText" (keyup.enter)="submitSearch()" (ngModelChange)="getAutocompleteResults()" [matAutocomplete]="auto" autocomplete="new-username" #trigger="matAutocompleteTrigger" />
  <mat-autocomplete #auto="matAutocomplete" class="edtell-autocomplete-search" (optionSelected)="getSelectedOption($event.option.value)">
    <mat-option *ngFor="let a of autocompleteResults" [value]="a" (click)="submitSearch(a)">
      {{ a.text }}
    </mat-option>
  </mat-autocomplete>
</ng-template>
